var map = {
	"./hosting_advice.png": "VEV7",
	"./html_goodies.png": "UkoP",
	"./internet_magazine.png": "PnzI",
	"./tucows.png": "NPwS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "O7RL";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/about ^\.\/.*\.png$
// module id = O7RL
// module chunks = 0